export default 'https://tme.understood.org/assets/background.afcf0924.glb'